import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { ISectionStyles } from "./Section.types"

export const SectionStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<ISectionStyles>
> = (theme: IPartialTheme) => ({
    root: {},
    labelContainer: {},
    label: {
        color: theme.palette?.neutralSecondary,
        fontWeight: "bold",
        padding: "0.5em 0 0 0",
        marginTop: "2em",
        fontSize: 18
    },
    parameters: {},
    containers: {}
})
